<script setup lang="ts">
defineEmits(['click'])
</script>

<template>
    <v-card
        variant="flat"
        class="border rounded-lg bg-blue-lighten-5 border-blue"
    >
        <v-card-text class="pa-5">
            <div>
                <p class="text-h6 black--text font-weight-medium">
                    You haven't received any transfers yet
                </p>
                Get started by <a
                    href="#"
                    class="text-blue"
                >sharing your project configuration</a>.
            </div>
        </v-card-text>
    </v-card>
</template>

<style scoped>
.border-blue {
    border-color: #64B5F6 !important;
}
</style>
